import type { FAQPage, WithContext } from "schema-dts";
import type { FAQItem } from "@/lib/types";
import { toHtml } from "./helpers";

export type FAQPageSchemaOptions = FAQItem[];

export function buildFAQPageSchema(
  items: FAQPageSchemaOptions,
): WithContext<FAQPage> {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map(item => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: toHtml(item.answer),
      },
    })),
  };
}
